import { render, staticRenderFns } from "./HistorySync.vue?vue&type=template&id=2bc8b077&scoped=true&"
import script from "./HistorySync.vue?vue&type=script&lang=js&"
export * from "./HistorySync.vue?vue&type=script&lang=js&"
import style0 from "./HistorySync.vue?vue&type=style&index=0&id=2bc8b077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8b077",
  null
  
)

export default component.exports